import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Col, message, Row, Spin } from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import * as quizActions from "../../../../../Redux/Actions/quizzesActions";
import edit from "../../../../../Assets/Images/edit.svg";
import deleteIcon from "../../../../../Assets/Images/delete.svg";
import "./QuizDetail.scss";

const QuizDetail = ({
  match,
  quizDetails,
  getQuizDetails,
  deleteQuiz,
  loading,
  history,
}) => {
  const quizId = match.params.quizId;
  const user = JSON.parse(localStorage.getItem("userdata"));
  const [question, setquestion] = useState();
  const [questionIndex, setQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState();

  //  Retrieves quiz details and questions based on the provided quiz ID.
  useEffect(() => {
    let data = {
      quiz_id: quizId,
    };
    getQuizDetails(data, user?.id);
  }, []);

  /**
   * Sets the first question of the quiz details as the current question.
   * @description - This effect is triggered when quizDetails is available and has at least one question.
   */
  useEffect(() => {
    quizDetails &&
      quizDetails?.questions?.length > 0 &&
      setquestion(quizDetails?.questions[0]);
  }, [quizDetails]);

  // Deletes the quiz based on the provided quiz ID and user ID.
  const onDeleteQuiz = () => {
    let data = {
      quiz_id: quizId,
      delete: true,
    };
    deleteQuiz(data, user?.id)
      .then(() => {
        message.success("Deleted");
        history.push({
          pathname: `/education/learn-investing/quizzes`,
          state: { searchPlaceholder: "Search Quiz", back: true },
        });
      })
      .catch((e) => {
        message.error(e || "Failed to delete");
      });
  };

  /**
   * Converts seconds to a time format (HH:mm:ss).
   * @param {number} d - Time in seconds.
   * @returns {JSX.Element} - Element representing the time in HH:mm:ss format.
   */
  const secondsToHms = (d) => {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);
    return (
      <div className="time-wrap">
        <div>
          <p className="value">{("0" + h)?.slice(-2)} : </p>
        </div>
        <div>
          <p className="value">{("0" + m)?.slice(-2)} : </p>
        </div>
        <div>
          <p className="value">{("0" + s)?.slice(-2)} </p>
        </div>
      </div>
    );
  };

  return (
    <div className="quiz-preview-container">
      <div className="preview-header">
        <h6>Quizzes</h6>
        <div className="header-right">
          <p
            onClick={() =>
              history.push(`/education/learn-series65/quiz-edit/${quizId}`)
            }
          >
            <img src={edit} alt="add" />
            <span>Edit</span>
          </p>
          <p onClick={() => onDeleteQuiz()}>
            <img src={deleteIcon} alt="add" />
            <span>Delete</span>
          </p>
        </div>
      </div>
      <div className="quiz-preview-wrap">
        {loading ? (
          <Spin />
        ) : (
          <Row gutter={16}>
            <Col span={5}>
              <div className="left-section">
                <h4>Quiz Time</h4>
                <div className="time-details">
                  <span>{secondsToHms(quizDetails?.time)}</span>
                </div>
              </div>
            </Col>
            <Col span={18} offset={1} className="content-wrap">
              <div className="question-wrap">
                <div className="question-content">
                  <span className="question">{question?.content}</span>
                </div>
                <div className="options">
                  <Row gutter={[24, 24]}>
                    {question?.options?.map((option) => (
                      <Col span={12}>
                        <div
                          onClick={() => setSelectedOption(option)}
                          className={`option ${
                            selectedOption === option
                              ? option === question?.correct_options
                                ? "correct-option"
                                : "incorrect-option"
                              : ""
                          }`}
                        >
                          <span>{option}</span>
                        </div>
                        {selectedOption === option && (
                          <div className="ans-message">
                            {selectedOption !== question?.correct_options ? (
                              <>
                                <CloseOutlined className="wrong-icon" />
                                <span className="wrong">Wrong Answer</span>
                              </>
                            ) : (
                              <>
                                <CheckOutlined className="right-icon" />
                                <span className="right">Correct Answer</span>
                              </>
                            )}
                          </div>
                        )}
                      </Col>
                    ))}
                  </Row>
                </div>
                {selectedOption && (
                    <div className="wrong-ans-wrap">
                      <span className="label">Answer Explanation</span>
                      <div className="expl-content">
                        <span>{question?.explanation}</span>
                      </div>
                    </div>
                  )}
                {quizDetails?.questions?.length > 1 && (
                  <div className="pre-next-wrap">
                    {questionIndex !== 0 && (
                      <div
                        className="prev-que"
                        onClick={() => {
                          setquestion(
                            quizDetails?.questions[questionIndex - 1]
                          );
                          setQuestionIndex(questionIndex - 1);
                          setSelectedOption();
                        }}
                      >
                        <ArrowLeftOutlined />
                        <span className="title">Previous Question</span>
                      </div>
                    )}
                    {questionIndex !== quizDetails?.questions?.length - 1 && (
                      <div
                        className="prev-que next-que"
                        onClick={() => {
                          setquestion(
                            quizDetails?.questions[questionIndex + 1]
                          );
                          setQuestionIndex(questionIndex + 1);
                          setSelectedOption();
                        }}
                      >
                        <span className="title">Next Question</span>
                        <ArrowRightOutlined />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.Quizzes.loading,
    quizDetails: state.Quizzes.quizDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getQuizDetails: (data, id) =>
      dispatch(quizActions.getQuizDetails(data, id)),
    deleteQuiz: (data, id) => dispatch(quizActions.deleteQuiz(data, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QuizDetail);
